var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Registration Submitted")]),_c('p',[_vm._v("An email has been sent to you at "+_vm._s(_vm.email)+" with further instructions.")])])}
var staticRenderFns = []

export { render, staticRenderFns }